import { DonutBlock as DonutBlockType } from '../../types/panel'

/* Ton-Farben strikt aus den Q90-Tokens */
const TONE_COLOR: Record<string, string> = {
  ok: 'var(--green-500)',
  warn: 'var(--gold)',
  danger: 'var(--red)',
  info: 'var(--green-900)',
}
const FALLBACK_COLORS = ['var(--green-900)', 'var(--green-500)', 'var(--gold)', 'var(--red)', 'var(--bone-3)']

interface Props { block: DonutBlockType }

/** Donut im Kontor-Stil — handgebautes SVG, Mono-Legende, Serif-Zentrum. */
export default function DonutBlock({ block }: Props) {
  const segments = Array.isArray(block.segments) ? block.segments : []
  const total = segments.reduce((sum, s) => sum + (Number(s.value) || 0), 0)
  if (total <= 0) return null

  const R = 70, STROKE = 22, C = 2 * Math.PI * R
  let offset = 0

  const segs = segments.map((s, i) => {
    const frac = s.value / total
    const seg = {
      ...s,
      color: TONE_COLOR[s.tone] ?? FALLBACK_COLORS[i % FALLBACK_COLORS.length],
      dash: `${(frac * C).toFixed(2)} ${(C - frac * C).toFixed(2)}`,
      offset: -offset * C,
    }
    offset += frac
    return seg
  })

  return (
    <div className="k-block">
      <h4 className="k-block__title">{block.title}</h4>
      <div className="k-donut">
        <svg width="180" height="180" viewBox="0 0 180 180" role="img" aria-label={block.title}>
          {segs.map((s, i) => (
            <circle
              key={i}
              cx="90" cy="90" r={R}
              fill="none"
              stroke={s.color}
              strokeWidth={STROKE}
              strokeDasharray={s.dash}
              strokeDashoffset={s.offset}
              transform="rotate(-90 90 90)"
            />
          ))}
          <text x="90" y="88" textAnchor="middle" className="k-donut__center-value">
            {total.toLocaleString('de-DE')}
          </text>
          <text x="90" y="106" textAnchor="middle" className="k-donut__center-label">
            {block.centerLabel}
          </text>
        </svg>
        <ul className="k-donut__legend">
          {segs.map((s, i) => (
            <li key={i}>
              <span className="k-donut__swatch" style={{ background: s.color }}></span>
              <span>{s.label}</span>
              <span className="val">{s.value.toLocaleString('de-DE')}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
